$ = jQuery.noConflict()

$(document).ready(function () {
  localStorage.removeItem('valuesBrand')
  localStorage.removeItem('viewNumbers')

  let prevScrollpos = $(window).scrollTop() + 70

  // On light pages the alternate (dark) logo is used at all times, so the
  // "top of page" logo equals data-brandtwo. In dark mode the header is dark
  // everywhere, so the light logo (data-brand) is used at all times.
  const isLightPage = document.body.classList.contains('has-light-page')
  const isDark = () => document.documentElement.classList.contains('dark')
  const topLogo = function () {
    if (isDark()) return $('#brand').data('brand')
    return isLightPage
      ? $('#brand').data('brandtwo')
      : $('#brand').data('brand')
  }
  // Logo shown once the header turns solid (scrolled): dark logo on light
  // header, light logo on the dark header used in dark mode.
  const scrolledLogo = () =>
    isDark() ? $('#brand').data('brand') : $('#brand').data('brandtwo')

  $(window).scroll(function () {
    const currentScrollPos = $(window).scrollTop()
    if ($(window).scrollTop() > 70) {
      if (prevScrollpos > currentScrollPos) {
        $('#masthead').addClass('actived')
        $('#masthead').css('top', '0')
        $('#brand').attr('src', scrolledLogo())
      } else {
        $('#masthead').css('top', '-125px')
        prevScrollpos = currentScrollPos
      }
    } else {
      if ($('#masthead').hasClass('proyect')) return $('#masthead').removeClass('actived')
      $('#masthead').removeClass('actived')
      $('#brand').attr('src', topLogo())
    }
  })
})
